import gql from 'graphql-tag';

export default gql`
    query GetAllTrailers($input: GetAllTrailersInput) {
        getAllTrailers(input: $input) {
            id
            name
        }
    }
`;
